module.exports = __webpack_public_path__ + "static/NotoSerif-Bold-14de05594f524b5ac5006a35c6ff4307.woff2";